import React from 'react'
import type { Icon } from 'shared/utils'

const Close = (props: Icon) => {
    const { color = 'white', size = 40, className = 'close' } = props
    return (
        <svg
            className={className}
            width={size}
            height={size}
            fill={color}
            viewBox="0 0 40 40"
            preserveAspectRatio="none">
            <path
                fillRule="evenodd"
                d="M22.665 20.001l7.942-7.941a1.883 1.883 0 0 0 0-2.666 1.883 1.883 0 0 0-2.665 0L20 17.336l-7.942-7.942a1.883 1.883 0 0 0-2.665 0 1.883 1.883 0 0 0 0 2.666L17.335 20l-7.94 7.94a1.883 1.883 0 0 0 0 2.666 1.883 1.883 0 0 0 2.665 0l7.94-7.94 7.94 7.94a1.883 1.883 0 0 0 2.666 0 1.883 1.883 0 0 0 0-2.665l-7.94-7.94z"
            />
        </svg>
    )
}

export { Close }
